import type { GuestTypesConfig } from "../api/contracts/site-config";
import type { GuestSelectLabels } from "./GuestSelect";

/** The four guest types as the site configures them, which is not how the activity panel
 *  counts them ("adults", "teenagers", …). */
export type GuestAgeTypeKey = "adult" | "teenager" | "child" | "infant";

/**
 * The age span a guest type is sold under: "Från 18 år" for adults, "11-17 år" for the rest.
 *
 * One rule for every surface that offers guest types, so the activity panel's participants read
 * the way the search bar's do rather than nearly. Falls back to the static copy when the site
 * configures no spans, which is what a site that has never set them up already shows.
 */
export const guestAgeSpanLabel = (
  guestType: GuestAgeTypeKey,
  labels: GuestSelectLabels,
  guestTypesConfig?: GuestTypesConfig,
): string => {
  if (!guestTypesConfig) {
    return {
      adult: labels.adultsSubtitle,
      teenager: labels.teenagersSubtitle,
      child: labels.childrenSubtitle,
      infant: labels.infantsSubtitle,
    }[guestType];
  }

  const config = guestTypesConfig[guestType];
  if (guestType === "adult") return labels.fromAge(config.minAge);

  const withMaxAge = config as { minAge: number; maxAge: number };
  return labels.ageRange(withMaxAge.minAge, withMaxAge.maxAge);
};
